import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import InstitutionsManagement   from '../../component/Admin/FoundationalTables/InstitutionsManagement';
import UserManager              from '../../component/Admin/FoundationalTables/UserManager';
import GeospatialReference      from '../../component/Admin/FoundationalTables/GeospatialReference';
import AuditLog                 from '../../component/Admin/FoundationalTables/AuditLog';
import SupplementaryDatasets    from '../../component/Admin/FoundationalTables/SupplementaryDataset';
import SpeciesLivestockRegistry from '../../component/Admin/FoundationalTables/SpeciesLivestockRegistry/SpeciesLivestockRgistry';
import FormRegistry             from '../../component/Admin/FoundationalTables/FormRegistry/FormRegistry';
import DepartmentRegistry       from '../../component/Admin/FoundationalTables/DepartmentRegistry';
import PppArrangementsTab       from '../../component/PPP/PppArrangementsTab';

import RegistryCentral          from '../../component/Admin/FoundationalTables/RegistryCentral/RegistryCentral';

const ADMIN_TABS = [
  { key: 'institutions',  label: 'Institution Management',             Component: InstitutionsManagement   },
  { key: 'users',         label: 'User Management',                    Component: UserManager              },
  { key: 'geospatial',    label: 'Geospatial Reference',               Component: GeospatialReference      },
  { key: 'audit',         label: 'Audit Log',                          Component: AuditLog                 },
  { key: 'supplementary', label: 'Supplementary Statistical Datasets', Component: SupplementaryDatasets    },
];

const REGISTRY_TABS = [
  { key: 'species',       label: 'Species & Livestock Registry',       Component: SpeciesLivestockRegistry },
  { key: 'departments',   label: 'FMLD Department Registry',           Component: DepartmentRegistry       },
  { key: 'forms',         label: 'Form Registry',                      Component: FormRegistry             },
  { key: 'ppp',           label: 'PPP Arrangement Registry',           Component: PppArrangementsTab       },
  { key: 'central',       label: 'Registry Central',                   Component: RegistryCentral          },
];

// System Management pages: /admin/<tab> and /registry-management/<tab>.
function TabbedSystemPage({ title, basePath, tabs }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const tabKey = pathname.split('/').filter(Boolean)[1];
  const active = tabs.find((t) => t.key === tabKey) ? tabKey : tabs[0].key;
  const Active = tabs.find((t) => t.key === active)?.Component ?? (() => null);

  return (
    <div className="p-6 bg-white min-h-screen">
      <h1 className="mb-5 text-xl font-bold text-gray-900">{title}</h1>

      <nav className="mb-5 flex flex-wrap gap-x-7 gap-y-2 border-b border-gray-200">
        {tabs.map((t) => {
          const isActive = active === t.key;
          return (
            <button
              key={t.key}
              type="button"
              onClick={() => navigate(`${basePath}/${t.key}`)}
              className={`relative pb-3 text-sm ${
                isActive ? 'font-semibold text-green-600' : 'font-medium text-gray-700 hover:text-green-700'
              }`}
            >
              {t.label}
              {isActive && <span className="absolute inset-x-0 -bottom-px h-0.5 rounded bg-green-600" />}
            </button>
          );
        })}
      </nav>
      <Active />
    </div>
  );
}

export default function Admin() {
  return <TabbedSystemPage title="Admin & Security" basePath="/admin" tabs={ADMIN_TABS} />;
}

export function RegistryManagement() {
  return <TabbedSystemPage title="Registry Management" basePath="/registry-management" tabs={REGISTRY_TABS} />;
}
